// extracted by mini-css-extract-plugin
export default {"FallbackPage":"FallbackPage_FallbackPage__ebZrD"};